<template>
  <v-container fluid>
    <v-card flat>
      <v-card-title v-if="standAloneMode">
        <v-toolbar>
          <v-icon color="brown">how_to_vote</v-icon>
          <v-toolbar-title class="font-weight-light">
            <v-row>
              <v-col>
                <div>&nbsp; Datos del Débito en Cuenta</div>
              </v-col>
            </v-row>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="hideActiveSubTask"
            ><v-icon>close</v-icon></v-btn
          >
        </v-toolbar>
      </v-card-title>

      <v-card-text>
        <v-row no-gutters>
          <v-col>
            <v-radio-group row v-model="model.debitoA">
              <v-radio label="A Titular" value="1"></v-radio>
              <v-radio label="A Garante" value="2"></v-radio>
              <v-radio label="Desactivado" value="0"></v-radio
              ><!-- v-if="standAloneMode" -->
            </v-radio-group>
          </v-col>
        </v-row>
        <!-- {{ model.cuentaBancoId }} -->
        <v-row v-if="!showNuevaCuenta" no-gutters>
          <v-col>
            <v-autocomplete
              v-model="model.cuentaBancoId"
              :items="cuentasBanco.filter((x) => x.activo)"
              item-text="cbu"
              item-value="id"
              label="Cuenta de Débito"
              placeholder="Seleccione la cuenta en la cual debitar"
              :menu-props="{ minWidth: '200' }"></v-autocomplete>
          </v-col>
          <v-col cols="1"> </v-col>
          <v-col cols="2">
            <v-autocomplete
              v-model="model.diaCobroId"
              :items="listDiasCobro"
              item-text="descripcion"
              item-value="id"
              label="Día de Cobro"
              :menu-props="{ minWidth: '200' }"
              :disabled="diaCobroDeshabilitado"></v-autocomplete>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-switch
              label="Agregar nueva Cuenta"
              v-model="showNuevaCuenta"></v-switch>
          </v-col>
        </v-row>
        <v-row v-if="showNuevaCuenta" no-gutters align="center">
          <v-col>
            <app-cuenta-banco-completo
              :value="cuentaBanco"
              @close-dialog="nuevaCuentaClosed"
              :cuentasExistentes="cuentasBanco"
              :showDelete="false"
              ref="editor"></app-cuenta-banco-completo>
          </v-col>
          <v-col cols="2">
            <v-autocomplete
              v-model="model.diaCobroId"
              :items="listDiasCobro"
              item-text="descripcion"
              item-value="id"
              label="Día de Cobro"
              :menu-props="{ minWidth: '200' }"
              :disabled="diaCobroDeshabilitado"></v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider v-if="standAloneMode"></v-divider>
      <v-card-actions v-if="standAloneMode">
        <v-btn color="blue darken-1" text @click.stop="hideActiveSubTask"
          >Cerrar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn color="green " dark @click.stop="save">Guardar Cambios</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import Vue from "vue";
import { http } from "@/axios";
import { mapGetters, mapMutations } from "vuex";

export default {
  data: () => ({
    editModeOn: false,
    loading: false,
    cuentasBanco: [],
    listDiasCobro: [],
    datosDebito: {},
    cuentaBanco: { orden: 1 },
    showNuevaCuenta: false,
    model: {
      debitoA: "0",
      cuentaBancoId: null,
      diaCobroId: 0,
      habilitarDiaCobro: true,
    },
    flagHabilitarDesactivarDebito: false,
    flagHabilitarActivarDebitoPv: false,
  }),
  props: {
    standAloneMode: {
      type: Boolean,
      default: true,
    },
    personaId: {
      type: String,
      required: false,
      default: null,
    },
    creditoId: {
      type: String,
      required: false,
    },
    cuentaSeleccionada: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
    // situación laboral actual del formulario de alta; en los flujos de carga no hay crédito
    // todavía, así que el flag habilitarDiaCobro (que sale del GET del crédito) no refleja
    // lo que el operador tiene en pantalla
    situacionLaboralActividadId: {
      type: [Number, String],
      required: false,
      default: null,
    },
    // los formularios que solo manejan la situación (no la actividad) pasan esta prop;
    // tipo 4 = jubilado/pensionado (pasivo ANSES)
    tipoSituacionLaboralId: {
      type: [Number, String],
      required: false,
      default: null,
    },
    // para pasivos: con estos datos el componente consulta el día de cobro del calendario ANSES
    documento: {
      type: String,
      required: false,
      default: null,
    },
    subSituacionLaboralId: {
      type: [Number, String],
      required: false,
      default: null,
    },
  },
  watch: {
    showNuevaCuenta: function () {
      if (this.showNuevaCuenta) {
        this.cuentaBanco = {
          esAlias: false,
          activo: true,
          cbu: "",
          cbuValidado: false,
          esDeOtroTitular: false,
          tipoCuentaId: 1,
          sucursalBanco: null,
          cuilTitular: null,
          nombreTitular: null,
          fechaAlta: this.$moment(new Date()).format("YYYY-MM-DD"),
          orden: 1,
        };
        this.cuentasBanco.push(this.cuentaBanco);

        Vue.nextTick(() => {
          // esto es para esperar a que se renderice el componente nuevo
          this.$refs.editor.editModeOn = true;
        });
      }
    },
    model: {
      handler() {
        this.setData();
      },
      deep: true,
    },
    esPasivoAnses: {
      // immediate: el componente suele montarse recién cuando el operador activa el
      // switch "Solicita Débito en Cuenta", con las props ya cargadas (sin cambios que
      // disparen el watcher)
      immediate: true,
      handler() {
        this.cargarDiaCobroAnses();
      },
    },
    subSituacionLaboralId() {
      this.cargarDiaCobroAnses();
    },
    personaId() {
      this.cargarDiaCobroAnses();
    },
  },
  computed: {
    ...mapGetters(["checkCanAccess"]),
    esPasivoAnses() {
      return (
        [41, 43, 44, 64].includes(
          Number(this.situacionLaboralActividadId),
        ) || Number(this.tipoSituacionLaboralId) === 4
      );
    },
    diaCobroDeshabilitado() {
      return (
        (this.standAloneMode && !this.checkCanAccess("ap-modifica-dia-cobro")) ||
        !this.model.habilitarDiaCobro ||
        this.esPasivoAnses
      );
    },
  },
  created() {
    this.loadDiasCobro();

    if (this.personaId) {
      this.loadCuentasBancoPersona();
    }

    if (this.creditoId) {
      this.loadDatosDebito();
    }
  },
  methods: {
    ...mapMutations([
      "hideActiveSubTask",
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
    ]),
    async nuevaCuentaClosed() {
      this.setData();
    },
    // para pasivos ANSES el día de cobro lo determina el calendario; el select está
    // bloqueado, así que lo consulto y lo muestro para poder continuar la carga
    async cargarDiaCobroAnses() {
      if (!this.esPasivoAnses) return;

      var query = null;
      if (this.documento && this.subSituacionLaboralId) {
        query =
          "documento=" +
          this.documento +
          "&subSituacionLaboralId=" +
          this.subSituacionLaboralId;
      } else if (this.personaId) {
        query = "personaId=" + this.personaId;
      } else {
        return;
      }

      try {
        var result = await http.get("cobranzas/getdiacobroanses?" + query);
        if (result.diaCobroId) this.model.diaCobroId = result.diaCobroId;
      } catch (error) {
        Vue.$log.error(error);
      }
    },
    async loadCuentasBancoPersona() {
      this.loading = true;
      try {
        var result = await http.get(
          "cuentasbanco/listporpersona?personaId=" + this.personaId,
        ); // traigo todas
        this.cuentasBanco = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    async loadDiasCobro() {
      this.loading = true;
      try {
        var result = await http.get("tiposdiacobro"); // traigo todas
        this.listDiasCobro = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadDatosDebito() {
      this.loading = true;
      try {
        var result = await http.get(
          "creditos/datosdebito?creditoId=" + this.creditoId,
        );
        this.datosDebito = result;

        console.log(this.datosDebito);

        if (this.datosDebito.debitoEnCuentaTitular) this.model.debitoA = "1";
        else if (this.datosDebito.debitoEnCuentaGarante)
          this.model.debitoA = "2";
        //esto es para permitir guardar datos en casos que tienen el debito en cuenta desactivado
        else this.flagHabilitarDesactivarDebito = true;

        this.model.cuentaBancoId = this.datosDebito.cuentaBancoId;
        this.model.diaCobroId = this.datosDebito.diaCobroId;
        this.model.habilitarDiaCobro = this.datosDebito.habilitarDiaCobro;

        // este GET trae el día PERSISTIDO de la persona; si el formulario dice que es
        // pasivo, el día lo vuelve a determinar el calendario ANSES (si no, esta
        // asignación pisa el día calculado por cargarDiaCobroAnses)
        if (this.esPasivoAnses) this.cargarDiaCobroAnses();

        // alert(JSON.stringify(this.datosDebito));

        if (this.datosDebito.esProductoCbu)
          this.flagHabilitarActivarDebitoPv = true;
        else this.flagHabilitarActivarDebitoPv = false;
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    setData() {
      Vue.set(this.cuentaSeleccionada, "creditoId", this.creditoId);
      Vue.set(this.cuentaSeleccionada, "altaCuenta", this.showNuevaCuenta);

      Vue.set(this.cuentaSeleccionada, "diaCobroId", this.model.diaCobroId);

      Vue.set(
        this.cuentaSeleccionada,
        "habilitarDiaCobro",
        this.model.habilitarDiaCobro,
      );

      if (this.cuentaSeleccionada.altaCuenta) {
        Vue.set(this.cuentaSeleccionada, "cbu", this.cuentaBanco.cbu);
        Vue.set(
          this.cuentaSeleccionada,
          "tipoCuentaId",
          this.cuentaBanco.tipoCuentaId,
        );
        Vue.set(
          this.cuentaSeleccionada,
          "sucursalBanco",
          this.cuentaBanco.sucursalBanco,
        );

        Vue.set(this.cuentaSeleccionada, "esAlias", this.cuentaBanco.esAlias);
        Vue.set(this.cuentaSeleccionada, "cuentaBancoId", null);
      } else {
        var cuenta = this.cuentasBanco.find(
          (i) => i.id == this.model.cuentaBancoId,
        );
        if (cuenta) {
          Vue.set(this.cuentaSeleccionada, "cbu", cuenta.cbu);
          Vue.set(this.cuentaSeleccionada, "tipoCuentaId", 0);
          Vue.set(this.cuentaSeleccionada, "sucursalBanco", null);
          Vue.set(this.cuentaSeleccionada, "esAlias", cuenta.esAlias);
          Vue.set(
            this.cuentaSeleccionada,
            "cuentaBancoId",
            this.model.cuentaBancoId,
          );
        } else {
          Vue.set(this.cuentaSeleccionada, "cbu", "");
          Vue.set(this.cuentaSeleccionada, "tipoCuentaId", 0);
          Vue.set(this.cuentaSeleccionada, "sucursalBanco", null);
          Vue.set(this.cuentaSeleccionada, "esAlias", false);
          Vue.set(
            this.cuentaSeleccionada,
            "cuentaBancoId",
            this.model.cuentaBancoId,
          );
        }
      }

      if (this.model.debitoA == "0") {
        Vue.set(this.cuentaSeleccionada, "debitoATitular", false);
        Vue.set(this.cuentaSeleccionada, "debitoAGarante", false);
      }
      if (this.model.debitoA == "1") {
        Vue.set(this.cuentaSeleccionada, "debitoATitular", true);
        Vue.set(this.cuentaSeleccionada, "debitoAGarante", false);
      }
      if (this.model.debitoA == "2") {
        Vue.set(this.cuentaSeleccionada, "debitoATitular", false);
        Vue.set(this.cuentaSeleccionada, "debitoAGarante", true);
      }
    },
    async save() {
      this.loading = true;

      try {
        this.setData();

        //No permito que desactiven el débito en cuenta de los créditos si no tienen un permiso puntual para hacerlo
        //Si permito que hagan modificaciones a la cuenta de debito si es un caso que no tiene el debito en cuenta activado
        if (!this.checkCanAccess("ap-desactivar-debito-cbu")) {
          if (
            this.model.debitoA == "0" &&
            !this.flagHabilitarDesactivarDebito
          ) {
            this.alertWarning(
              "No está habilitado para desmarcar el débito en cuenta de un crédito. Esa acción requiere permisos especiales.",
            );
            return;
          }
        }

        if (
          !this.checkCanAccess("ap-activar-credito-pv") &&
          !this.flagHabilitarActivarDebitoPv &&
          (this.model.debitoA == "1" || this.model.debitoA == "2")
        ) {
          this.alertWarning(
            "No está habilitado para activar la marca de débito para pago voluntario. Esa acción requiere permisos especiales.",
          );
          return;
        }

        console.log(this.cuentaSeleccionada);

        await http.post(
          "creditos/updatedatosdebito",
          JSON.stringify({ parametros: this.cuentaSeleccionada }),
        );
        this.alertSuccess("Los cambios han sido registrados");

        // recargo
        (this.showNuevaCuenta = false), this.loadCuentasBancoPersona();
        this.loadDatosDebito();
      } catch (error) {
        // Error
        Vue.$log.error(error);
        this.alertError(error);
      }
      this.loading = false;
    },
  },
};
</script>
